import * as React from "react";
const Menu = (props) => (
  <svg
    width={props.width}
    height={props.height}
    viewBox="0 0 25 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M23.8494 1.61426H1.69554C1.19092 1.61426 0.772461 1.27426 0.772461 0.864258C0.772461 0.454258 1.19092 0.114258 1.69554 0.114258H23.8494C24.354 0.114258 24.7725 0.454258 24.7725 0.864258C24.7725 1.27426 24.354 1.61426 23.8494 1.61426Z"
      fill={props.fill}
    />
    <path
      d="M23.8494 9.11426H1.69554C1.19092 9.11426 0.772461 8.77426 0.772461 8.36426C0.772461 7.95426 1.19092 7.61426 1.69554 7.61426H23.8494C24.354 7.61426 24.7725 7.95426 24.7725 8.36426C24.7725 8.77426 24.354 9.11426 23.8494 9.11426Z"
      fill={props.fill}
    />
    <path
      d="M23.8494 16.6143H1.69554C1.19092 16.6143 0.772461 16.2743 0.772461 15.8643C0.772461 15.4543 1.19092 15.1143 1.69554 15.1143H23.8494C24.354 15.1143 24.7725 15.4543 24.7725 15.8643C24.7725 16.2743 24.354 16.6143 23.8494 16.6143Z"
      fill={props.fill}
    />
  </svg>
);
export default Menu;
